import { render, staticRenderFns } from "./MoreInformation.vue?vue&type=template&id=e652735a&scoped=true"
import script from "./MoreInformation.vue?vue&type=script&lang=js"
export * from "./MoreInformation.vue?vue&type=script&lang=js"
import style0 from "./MoreInformation.vue?vue&type=style&index=0&id=e652735a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e652735a",
  null
  
)

export default component.exports